import { FormModel } from 'components/Form';
import { CountryCode } from 'libphonenumber-js';
import dayjs from 'dayjs';
import { Validators } from 'utils/validators';

export const AddRfqForm = (
  strings: any,
  defaultCountryCode: CountryCode,
  eventTypeList: any[],
  venueTypeList: any[],
  pricePackageList: any[],
  disabled: boolean,
  maxCapacity: number,
  isOdc: boolean,
): FormModel[] => {
  const today = dayjs(new Date());
  return [
    {
      label: strings.add_rfq_text_event_type,
      value: '',
      autoFocus: false,
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'eventId',
      validators: [],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      options: eventTypeList,
    },
    {
      label: strings.new_booking_event_sub_type,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'eventSubtype',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
    {
      label: strings.add_rfq_text_venue,
      value: '',
      autoFocus: false,
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'venueId',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      options: venueTypeList,
    },
    ...(isOdc
      ? [
          {
            label: strings.customerDetailsPlaceOfEvent,
            value: '',
            size: 'medium',
            autoFocus: false,
            type: 'text',
            typeValue: 'text',
            variant: 'outlined',
            placeholder: '',
            field: 'placeOfEvent',
            validators: [{ check: Validators.validateString }],
            responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
            required: false,
          },
          {
            label: strings.customerDetailsAddress,
            value: '',
            size: 'medium',
            autoFocus: false,
            type: 'text',
            typeValue: 'text',
            variant: 'outlined',
            placeholder: '',
            field: 'addressOfEvent',
            validators: [{ check: Validators.validateString }],
            responsive: { xs: 12, sm: 6 },
            required: false,
          },
        ]
      : []),
    {
      label: strings.add_rfq_text_guests,
      value: '',
      autoFocus: false,
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'guests',
      validators: [
        { check: Validators.validateMandatoryField },
        {
          check: Validators.validateInt,
          message: strings.formatString(strings.rfq_max_capacity_error, maxCapacity),
          max: maxCapacity,
        },
      ],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      label: strings.add_rfq_text_price_package,
      value: '',
      autoFocus: false,
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'pricePackageId',
      validators: [],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      options: pricePackageList,
      disabled: disabled,
    },
    {
      label: strings.add_rfq_text_date,
      value: '',
      autoFocus: true,
      type: 'date',
      typeValue: 'text',
      placeholder: '',
      field: 'preferredStartDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      minDate: today,
    },
    {
      label: strings.add_rfq_text_end_date,
      value: '',
      autoFocus: false,
      type: 'date',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'preferredEndDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      minDate: today,
    },
    {
      label: `${strings.timeSlot_column_startTime}`,
      value: '',
      size: 'medium',
      type: 'time',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'startTime',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      label: `${strings.timeSlot_text_endTime}`,
      value: '',
      size: 'medium',
      type: 'time',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'endTime',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      label: strings.customermgmt_text_firstName,
      value: '',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'firstName',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      label: strings.customermgmt_text_lastName,
      value: '',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'lastName',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      label: strings.add_rfq_text_mobile,
      value: '',
      size: 'medium',
      type: 'phoneInput',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'mobile',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateMobile }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      defaultCountry: defaultCountryCode,
    },
    {
      label: strings.add_rfq_text_email,
      value: '',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'email',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateEmail },
        { check: Validators.validateString },
      ],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      label: strings.add_rfq_text_company_name,
      value: '',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'companyName',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
  ];
};
